export default __webpack_public_path__ + "static/media/warning--low-flying-aircraft--g7.0ae82c4d.png";